import {prepareAntibodyCreateInputs} from 'antibodies/nested-data-creation/AntibodyNestedDataCreationUtil';
import {
  AntibodyPairAwareCreateInput,
  TranslationParameters,
} from 'antibodies/nested-data-creation/constants/AntibodyNestedDataCreationConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface NestedCreateAndRegisterAntibodiesInput {
  projectFolderId: string;
  antibodySchemaId: string;
  antibodyCreateInputs: Array<AntibodyPairAwareCreateInput>;
  translationParameters: TranslationParameters;
}

/**
 * Creates and registers antibodies from the provided DNA pair IDs.
 *
 * @param projectFolderId - project folder API ID where all new entities will be created
 * @param antibodySchemaId - antibody schema API ID
 * @param antibodyCreateInputs - List of antibodies to create.
 * @param translationParameters - parameters for translating DNA to amino acids
 */
export function nestedCreateAndRegisterAntibodies({
  projectFolderId,
  antibodySchemaId,
  antibodyCreateInputs,
  translationParameters,
}: NestedCreateAndRegisterAntibodiesInput): Promise<{createdAllEntities: boolean; ndcWorkspaceUrl?: string}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:nested-create-and-register',
    data: {
      createAntibodiesData: {
        requestType: 'NDC_PIPELINE_REQUEST_V0',
        folderId: projectFolderId,
        antibodySchemaId,
        antibodyCreateInputs: antibodyCreateInputs.map((input) => prepareAntibodyCreateInputs(input)),
        translationParameters,
      },
    },
  });
}
